export default __webpack_public_path__ + "static/media/no-welting.9ac3b8c9.webp";